import api from './index';

export const getUsersByCompany = async (company_id, query) => {
  try {
    const { data } = await api.get(`/companies/${company_id}/users${query ? `?${query}` : ''}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export async function getUserByCheckoutToken(checkout_token) {
  try {
    const { data } = await api.get(`/checkout/${checkout_token}/user`);
    return data;
  } catch (error) {
    throw error;
  }
}

export const getUserByEmail = async (email) => {
  try {
    const { data } = await api.get(`/only-user/${email}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export async function createUser(user) {
  try {
    const { data } = await api.post('/user', {
      user: {
        ...user,
        source: process.env.SOURCE.toLocaleLowerCase(),
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
}

export const createUserLinkTask = async (user) => {
  try {
    const { data } = await api.post('/user', user);
    return data;
  } catch (error) {
    throw error;
  }
};

export async function updateUser(user) {
  try {
    const { data } = api.put(`/user/${user.id}`, { user });
    return data;
  } catch (error) {
    throw error;
  }
}

export async function registerSession(userSession) {
  try {
    const { data } = api.post(`/users/${userSession.user_id}/sessions`, { ...userSession });
    return data;
  } catch (error) {
    throw error;
  }
}
